export class TerceroModel{
	constructor(public defTiposdocumentos:DefTiposdocumentos,
		public id:MchTercerosId,
		public ndigchk:number,
		public vnombre:string,
		public vapellido:string,
		public vapellido2:string,
		public nestado:any,
		public bloquear:number,
		public defTipospersona:DefTipospersona,
		//public paramNegocios:ParamNegocios,
		public defContribuyentes:DefContribuyentes,
		public vcodigotri : string,
		public vresponfis : string){

	}
}




export class ParamNegocios{	
	constructor(public id:ParamNegociosId){}
}
export class ParamNegociosId{
	constructor(public cnumcont:string, public ntipoempresa:number){}
}
export class DefTiposdocumentos{
	constructor(public ctipid:string){}
}
export class DefTipospersona{
	constructor(public ntipper:string){}
}
export class MchTercerosId{
	constructor(public cnumid:string,public cnumcont:string,public ctipid:string, public ntipoempresa:number){}
}
export class DefContribuyentes{
	constructor(public nidcontribuyente:string){}
}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Tercero/Tercero.model.ts